export default {
  title: "Aperçu de l'entreprise",
  description: 'Bienvenue, {{name}} ! Voici ce qui se passe avec votre marketing.',
};
